<!-- @format -->

<ng-container *ngIf="starsIcon">
	<ng-container *ngFor="let star of starsIcon; trackBy: trackByStar">
		<homefield-icon
			[name]="star"
			width="{{ options.width }}"
			height="{{ options.height }}"></homefield-icon>
	</ng-container>
</ng-container>
